import { MODULE_META } from "./moduleKeys";

// Every user-facing module noun goes through this one lookup. It uses the
// client's vocabulary first (clients.config.vocabulary) and falls back to
// the module's built-in default. It falls back to the raw module key only
// for an unknown key, and never to an empty string.
//
// Per spec section 2, BBP's and Sambecca's default vocabulary (once the
// client layer from 2026-09-23-client-sites-design.md exists and each gets
// a clients.config row) is:
//   jobs:      { one: "Estimate",  many: "Estimates" }
//   reports:   { one: "Takeoff",   many: "Takeoffs" }
//   templates: { one: "Unit Type", many: "Unit Types" }
//   catalog:   { one: "Rate",      many: "Rates" }
// Not applied anywhere yet - no clients table exists on this branch.
export function label(key, count = 1, vocabulary = {}) {
  const form = count === 1 ? "one" : "many";
  const custom = vocabulary?.[key]?.[form];
  if (custom && String(custom).trim()) return String(custom).trim();
  return MODULE_META[key]?.defaultLabel?.[form] || key;
}
